/**
 * Copilot Studio portal POC — gated so Fact Finder and other routes stay unchanged.
 * Enable only on UAT (or local) builds until Studio channel + security are signed off.
 * The sidebar item also requires the instance flag enableCopilotStudio.
 *
 * transport=sdk calls the agent with the signed-in user's Entra token
 * (Microsoft 365 Agents SDK protocol) so SharePoint answers use that user's access.
 * transport=iframe is the no-auth webchat embed and does not apply SharePoint ACL.
 */
export const isCopilotStudioEnabled =
  process.env.REACT_APP_ENABLE_COPILOT_STUDIO === "true"

export type CopilotStudioTransport = "sdk" | "iframe"

/** sdk is the SharePoint-access path. Set REACT_APP_COPILOT_STUDIO_TRANSPORT=iframe for the embed smoke test. */
export const copilotStudioTransport: CopilotStudioTransport =
  process.env.REACT_APP_COPILOT_STUDIO_TRANSPORT === "iframe" ? "iframe" : "sdk"

/** Full webchat URL from Copilot Studio Custom website / Web app channel (iframe src). */
export const copilotStudioWebchatUrl =
  process.env.REACT_APP_COPILOT_STUDIO_WEBCHAT_URL ?? ""

export const isCopilotStudioIframeReady =
  isCopilotStudioEnabled && Boolean(copilotStudioWebchatUrl.trim())

/** Standard-harness agent. Overridable if Studio issues a different schema name. */
export const copilotStudioEnvironmentId =
  process.env.REACT_APP_COPILOT_STUDIO_ENVIRONMENT_ID ||
  "7d1eef85-c1b9-e2f2-a67f-b3fd5845de9c"

export const copilotStudioSchemaName =
  process.env.REACT_APP_COPILOT_STUDIO_SCHEMA_NAME ||
  "cr9d4_LabWizardStandardAgent11"

export const copilotStudioTenantId =
  process.env.REACT_APP_COPILOT_STUDIO_TENANT_ID ||
  "fe9c4641-3b53-43d0-af72-8f3e64d3aa05"

/**
 * Entra app LabWizard Copilot Studio (delegated CopilotStudio.Copilots.Invoke).
 */
export const copilotStudioClientId =
  process.env.REACT_APP_COPILOT_STUDIO_CLIENT_ID ||
  "542fb125-70b3-4019-bd38-dc816f9a80f2"

/** Optional. Channels → Web app → Microsoft 365 Agents SDK connection string. */
export const copilotStudioDirectConnectUrl =
  process.env.REACT_APP_COPILOT_STUDIO_DIRECT_CONNECT_URL || ""

export const copilotStudioScope =
  "https://api.powerplatform.com/CopilotStudio.Copilots.Invoke openid profile offline_access"
